import { observer } from 'mobx-react';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { ApplicationRoutes } from '../../../../../application/constants/routes';
import { useI18n } from '../../../../../application/language/useI18n';
import { ListItemLink } from '../../../../design/list/ListItemLink';
import { IMainLayoutDomainStore } from '../../store/domain/IMainLayoutDomainStore';

export interface ILearningNavigation {
  layoutDomain: IMainLayoutDomainStore;
}
export const LearningNavigation = observer(({}: ILearningNavigation) => {
  const { translate } = useI18n();
  const { pathname } = useLocation();

  return (
    <ListItemLink
      itemKey="learning"
      url={ApplicationRoutes.LearningRoot}
      primaryText={translate('navigation.learning')}
      isSelected={pathname.startsWith(ApplicationRoutes.LearningRoot)}
    />
  );
});
